import { Action, IOWidget, mk_widget, AsyncState } from 'widgets-for-react'
import React from 'react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { NavLink } from 'react-router-dom'
import { WordPress } from '../../../../wordpress/wordpress_api'

type displayLatesUpdates = { kind: 'latest' }
type displaySelectedUpdates = { kind: 'selected'; ids: Array<number> }
import { PublicSiteState } from '../../../../public_site.main.mod'
import { toRelativeUrl } from '../../../../../helpers'
import * as Moment from 'moment'
import { getImageSize, getImageAttribute } from '../../../utils/extra_images.mod'

export type LatestBlockProps = {
  title: string
  hasBackground?: boolean
  button?: {
    title: string
    url: string
  }
  display: displayLatesUpdates | displaySelectedUpdates
}

export type UpdateProps = {
  title: string
  date?: string
  image?: WordPress.Image
  url: string
  key?: number
}

export type LatestBlockStyle = Partial<{}>

export function LatestBlock<CustomBlockData, extra_images>(
  props: LatestBlockProps,
  options?: { style?: LatestBlockStyle; key?: string }
): (
  s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>
) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: onDone => (
        <section className={`block block--updates ${props.hasBackground ? `block--updates--blue` : ''}`}>
          <div className="block__inner">
            <header className="block--updates__header">
              <h2 className="block--updates__title">{props.title}</h2>
              {props.button && props.button.title && props.button.url && (
                <div className="block--updates__action">
                  <NavLink
                    className={`btn btn--secondary ${props.hasBackground ? 'btn--secondary--white' : ''}`}
                    to={props.button.url}
                  >
                    {props.button.title}
                  </NavLink>
                </div>
              )}
            </header>

            {/* <div className="block--updates__content">
              {props.display.kind == 'selected' ? (
                public_state.latest_updates.kind == 'loaded' && public_state.latest_updates.value.slice(0, 3).map((update, index) => (
                  <Update
                    title={update.title.rendered}
                    image={update.featured_media_object}
                    date={update.date ? update.date : null}
                    url={update.link}
                    key={update.id}
                  />
                ))
              ) : public_state.latest_updates.kind == 'loaded' && public_state.latest_updates.value.slice(0, 3).map((update, index) => (
                  <Update
                    title={update.title.rendered}
                    image={update.featured_media_object}
                    date={update.date ? update.date : null}
                    url={update.link}
                    key={update.id}
                  />
                ))
              }
            </div> */}
          </div>
        </section>
      )
    })
}

export function Update(props: UpdateProps): JSX.Element {
  return (
    <NavLink className="tile tile--link" to={toRelativeUrl(props.url)} key={props.key ? props.key : ''}>
      <header className="tile__header">
        <h3 className="tile__title" dangerouslySetInnerHTML={{ __html: props.title }}></h3>
      </header>

      {props.date && <span className="tile__date">{ Moment.default(props.date).format('D-MM-YYYY') }</span>}

      {props.image && (
        <div className="tile__visual">
          <img
            src={getImageAttribute(props.image, 'teaser', 'source_url')}
            width={getImageAttribute(props.image, 'teaser', 'width')}
            height={getImageAttribute(props.image, 'teaser', 'height')}
            className="tile__image"
            alt={props.image.alt_text ? props.image.alt_text : props.title}
          />
        </div>
      )}
    </NavLink>
  )
}
